<template>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="mx-auto col-lg-12 col-12">
          <div class="mt-4 card card-body">
            <div id="user-recap" class="user-recap">
              <!-- Company Details -->
              <div class="row">
                <div class="col-6">
                  <div class="company-details">
                    <div class="logo-container">
                      <img src="@/assets/img/smartintrade-logo-new.png" alt="Logo" class="company-logo" />
                      <h3 class="company-name">PT. Smartin Advisor Sistem</h3>
                    </div>
                    <p class="contact-info">+62 821 1830 6880 | admin@smartintrade.co.id</p>
                  </div>
                </div>
                <div class="col-6 text-right">
                  <h2 class="user-title">User Recap</h2>
                  <p class="user-date"><strong>Date:</strong> {{ formatDate(new Date()) }}</p>
                  <p class="user-id"><strong>User ID:</strong> {{ record.id }}</p>
                </div>
              </div>
  
              <!-- User Details -->
              <div class="row">
                <div class="col-12">
                  <h4 class="section-title">User Details</h4>
                  <table class="table table-bordered">
                    <tbody>
                      <tr><th>Full Name</th><td>{{ record.fullname }}</td></tr>
                      <tr><th>Username</th><td>{{ record.username }}</td></tr>
                      <tr><th>Email</th><td>{{ record.email }}</td></tr>
                      <tr><th>Phone</th><td>{{ record.phone }}</td></tr>
                      <tr><th>Company</th><td>{{ record.company }}</td></tr>
                      <tr><th>Birth Date</th><td>{{ formatDate(record.birth_date) }}</td></tr>
                      <tr><th>Place of Birth</th><td>{{ record.place_of_birth }}</td></tr>
                      <tr><th>Gender</th><td>{{ formatGender(record.gender) }}</td></tr>
                      <tr><th>Residential Address</th><td>{{ record.residential_address }}</td></tr>
                      <tr><th>Current Address</th><td>{{ record.current_address }}</td></tr>
                      <tr><th>KYC Status</th><td>{{ record.kyc_status }}</td></tr>
                      <tr><th>KYC Rejection Reason</th><td>{{ record.kyc_rejection_reason || '-' }}</td></tr>
                      <tr><th>ID Card Number</th><td>{{ record.id_card_number }}</td></tr>
                      <tr><th>ID Card Type</th><td>{{ record.id_card_type }}</td></tr>
                      <tr>
                        <th>ID Card Image</th>
                        <td>
                          <img :src="record.id_card_image" alt="ID Card" class="preview-image" />
                          <p><a :href="record.id_card_image" target="_blank">View Full</a></p>
                        </td>
                      </tr>
                      <tr><th>Trading Type</th><td>{{ record.trading_type }}</td></tr>
                      <tr><th>NPWP</th><td>{{ record.npwp }}</td></tr>
                      <tr><th>NPWP Type</th><td>{{ record.npwp_type }}</td></tr>
                      <tr>
                        <th>NPWP Image</th>
                        <td v-if="record.npwp_image && record.npwp_type === 'NPWP'">
                          <img :src="record.npwp_image" alt="NPWP" class="preview-image" />
                          <p><a :href="record.npwp_image" target="_blank">View Full</a></p>
                        </td>
                        <td v-else>-</td>
                      </tr>
                      <tr><th>Country</th><td>{{ record.country }}</td></tr>
                      <tr><th>Province</th><td>{{ record.province }}</td></tr>
                      <tr><th>City</th><td>{{ record.city }}</td></tr>
                      <tr><th>Postal Code</th><td>{{ record.postal_code }}</td></tr>
                      <tr><th>Employee Type</th><td>{{ record.employee_type }}</td></tr>
                      <tr><th>Annual Income</th><td>{{ record.annual_income }}</td></tr>
                      <tr><th>Bank Name</th><td>{{ record.bank_name }}</td></tr>
                      <tr><th>Bank Account Name</th><td>{{ record.bank_account_name }}</td></tr>
                      <tr><th>Bank Account Number</th><td>{{ record.bank_account_number }}</td></tr>
                      <tr>
                        <th>Referral Link</th>
                        <td>
                          <a :href="record.link_referral" target="_blank">{{ record.link_referral }}</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
  
              <!-- Download PDF -->
              <div class="row">
                <button class="btn btn-primary mt-5 w-40 mx-auto" @click="generatePDF">Download PDF</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import UsersService from "@/services/users.service.js";
import { ref } from 'vue';
import { toast } from 'vue3-toastify';

const toastId = ref('');


export default {
    name: "ExternalUserRecap",

  data() {
    return {
      record: {},
    };
  },
  mounted(){
    this.getRecord()
  },
  methods: {
    showLoading(){
      toastId.value = toast.loading('Please wait...');
    },
    hideLoading(){
      setTimeout(() => {
        toast.remove(toastId.value)
      }, 1000); 
    },
    showFailed(e){
      toast.update(toastId.value, {
        render: e,
        closeOnClick: true,
        closeButton: true,
        type: 'error',
        isLoading: false,
        autoClose: 3000
      });
    },
    getRecord(){
      this.showLoading()

      UsersService.get(this.$route.params.id).then(e => {
        this.record = e.data.registration_data
        this.record.password = ''
        
        this.hideLoading()
      }).catch(e => {
        this.showFailed(e.response.data.code_message)           
      });
    },
    async generatePDF() {
        const html2pdf = await import("html2pdf.js");
        const element = document.getElementById("user-recap");

        const preloadImages = () => {
        const images = document.querySelectorAll("#user-recap img");
        const promises = Array.from(images).map(
          (img) =>
            new Promise((resolve, reject) => {
              if (img.complete) resolve();
              else {
                img.onload = resolve;
                img.onerror = reject;
              }
            })
        );
        return Promise.all(promises);
      };
  
        try {
            await preloadImages();

            html2pdf
          .default()
          .from(element)
          .set({
            margin: [0.5, 0.5, 0.5, 0.5],
            filename: `${this.record.id || "user-recap"}.pdf`,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: {
              scale: 3,
              scrollX: 0,
              scrollY: 0,
              windowWidth: element.scrollWidth,
              windowHeight: element.scrollHeight,
              useCORS: true,
            },
            jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
          })
          .save();
        } catch (error) {
            console.error("Error generating PDF:", error);
            this.showFailed("Failed to generate PDF");
        }
    },
    formatGender(gender){
        return gender === "m" ? "Male" : gender === "f" ? "Female" : "-";
    },
    formatDate(date) {
        if (!date) return "-";
        return new Date(date).toLocaleDateString("id-ID", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
    }
  }
};
</script>
  
  <style scoped>
  .user-recap {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 8px;
  font-family: Arial, sans-serif;
}

.company-details {
  display: flex;
  flex-direction: column;
}

.logo-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.company-logo {
  max-width: 50px;
  margin-right: 10px;
}

.table-bordered {
  width: 100%;
  border-collapse: collapse;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
}

.preview-image {
  max-width: 200px;
  max-height: 150px;
  margin-bottom: 10px;
}
  </style>